{
  "hero": {
    "title": "Fai oro come se <em>fosse il tuo lavoro.<br/></em>",
    "subtitle": "Intelligenza di flipping cross-realm per la casa d'aste Retail. Dati in tempo reale, presentati come le offerte da cogliere — non un altro grafico da leggere.",
    "ctaPrimary": "Inizia una prova gratuita",
    "ctaSecondary": "Vedilo in azione",
    "stats": {
      "regions": "Regioni",
      "regionsValue": "EU · US",
      "updated": "Aggiornamento",
      "updatedValue": "Ogni ora"
    }
  },
  "toolsSection": {
    "label": "Strumenti",
    "sectionTitle": "Sei strumenti. Un solo obiettivo: oro.",
    "watchDemo": "Guarda la demo",
    "tags": {
      "flippingTool": "Cross-realm",
      "dropshipTool": "Mercati vuoti",
      "realmStats": "Dati",
      "tsmListGenerator": "Export TSM",
      "snipeAlerts": "Tempo reale",
      "inventoryAnalysis": "Scan inventario"
    }
  },
  "tools": {
    "flippingTool": {
      "title": "Strumento di Flipping",
      "description": "Strumento di flipping cross-realm che analizza le migliori offerte per un oggetto.",
      "videoTitle": "Strumento di Flipping Cross-Realm",
      "features": {
        "0": "Trova la migliore offerta per un oggetto basandosi su dati in tempo reale.",
        "1": "Seleziona regni specifici su cui vuoi comprare e vendere.",
        "2": "Mostra il profitto in oro dal regno d'acquisto vs. vendita.",
        "3": "Calcola la % di profitto per la media di vendita vs. acquisto e vendita vs. acquisto.",
        "4": "Mostra esattamente da quale regno/cluster di regni comprare e su cui vendere.",
        "5": "Filtri/ordinamento per diversi tipi di oggetti e statistiche di prezzo"
      }
    },
    "dropshipTool": {
      "title": "Strumento di Dropship",
      "description": "Strumento di dropship che mostra quali oggetti non sono presenti su un server per flipparli senza concorrenza.",
      "videoTitle": "Strumento di Dropship",
      "features": {
        "0": "Trova il miglior server su cui vendere senza concorrenza",
        "1": "Seleziona regni specifici su cui vuoi comprare e vendere.",
        "2": "Mostra il profitto in oro dal regno d'acquisto vs. vendita.",
        "3": "Calcola la % di profitto per la media di vendita vs. acquisto e vendita vs. acquisto.",
        "4": "Mostra esattamente da quale regno/cluster di regni comprare e su cui vendere.",
        "5": "Filtri/ordinamento per diversi tipi di oggetti e statistiche di prezzo"
      }
    },
    "realmStats": {
      "title": "Statistiche del Regno",
      "description": "Informazioni statistiche su ogni regno, prezzi e informazioni sulle aste. Questo ti aiuta a decidere dove comprare e dove vendere.",
      "videoTitle": "Statistiche del Regno",
      "features": {
        "0": "Trova informazioni sui prezzi di ogni regno",
        "1": "Scopri quali server vendono a prezzi alti o bassi"
      }
    },
    "tsmListGenerator": {
      "title": "Generatore di Liste TSM",
      "description": "Strumento avanzato di generazione di liste TSM per creare liste di oggetti personalizzate basate sui dati.",
      "videoTitle": "Generatore di Liste TSM",
      "features": {
        "0": "Usa più fonti di prezzo per filtrare i migliori oggetti",
        "1": "Crea la lista TSM perfetta basandoti su un'ampia gamma di dati.",
        "2": "Esporta la tua lista TSM personalizzata con 1 clic."
      }
    },
    "snipeAlerts": {
      "title": "Allerte Snipe",
      "description": "Ricevi una notifica nel momento in cui appaiono oggetti sottoprezzo, mascotte o BoE ilvl in casa d'aste — prima che qualcun altro li accaparri.",
      "videoTitle": "Anteprima Allerte Snipe",
      "features": {
        "0": "Monitora oggetti, mascotte da battaglia e BoE ilvl sotto il tuo prezzo obiettivo.",
        "1": "Ricevi DM Discord o webhook istantanei quando viene trovato uno snipe.",
        "2": "Configura soglie per oggetto con un'interfaccia semplice e pulita."
      }
    },
    "inventoryAnalysis": {
      "title": "Analisi Inventario",
      "description": "Incolla il CSV di inventario del tuo addon FlipQueue per vedere immediatamente quali oggetti conviene flippare cross-realm. Usa il risultato nell'addon per mettere in vendita sui migliori server.",
      "videoTitle": "Analisi Inventario",
      "features": {
        "0": "Analizza il tuo inventario attuale contro i prezzi cross-realm in tempo reale.",
        "1": "Individua all'istante quali oggetti nelle borse sono redditizi da flippare."
      }
    }
  },
  "edge": {
    "label": "Il vantaggio",
    "sectionTitle": "Perché i membri rinnovano l'abbonamento.",
    "items": {
      "0": {
        "title": "Più oro.",
        "body": "Mostriamo i flip a margine più alto per minuto di sforzo. Il tuo oro-all'ora è la cifra che ottimizziamo."
      },
      "1": {
        "title": "Riprenditi le serate.",
        "body": "Ore di scansioni TSM si riducono a un'interfaccia consultabile. Filtra, ordina, esporta una lista TSM, fatto."
      },
      "2": {
        "title": "Comincia stasera.",
        "body": "Niente fogli di calcolo, niente addon pesanti. La maggior parte dei membri fa il primo flip redditizio il primo giorno."
      }
    }
  },
  "reviews": {
    "label": "Recensioni",
    "sectionTitle": "Cosa dicono i nostri membri.",
    "videoTitle": "Recensioni dei membri di FlippingPal"
  },
  "pricing": {
    "label": "Abbonamento",
    "sectionTitle": "Un abbonamento. Tutti gli strumenti.",
    "subtitle": "L'abbonamento dà accesso a tutti gli strumenti di Flipping Pal"
  },
  "faq": {
    "label": "Domande",
    "sectionTitle": "Domande frequenti.",
    "items": {
      "0": {
        "question": "Ho accesso a tutti gli strumenti con l'abbonamento mensile?",
        "answer": "Sì, avrai accesso completo a tutti gli strumenti di Flipping Pal."
      },
      "1": {
        "question": "In quale regione WoW funziona?",
        "answer": "Sia US (NA) che EU (Europa)."
      },
      "2": {
        "question": "Posso cancellare l'abbonamento in qualsiasi momento?",
        "answer": "Sì, puoi farlo in qualsiasi momento. Una volta cancellato, perderai l'accesso agli strumenti."
      },
      "3": {
        "question": "Quali metodi di pagamento sono accettati?",
        "answer": "Qualsiasi carta di debito/credito."
      },
      "4": {
        "question": "Se ho domande, riceverò assistenza?",
        "answer": "Sì, se hai domande chiedi al team su Discord."
      }
    }
  },
  "modal": {
    "close": "Chiudi"
  },
  "backToTop": "Torna su",
  "footerCta": {
    "joinAsAffiliate": "Diventa affiliato",
    "contactUs": "Contattaci",
    "discord": "Discord",
    "refundPolicy": "Politica di rimborso",
    "privacyPolicy": "Informativa sulla privacy",
    "termsAndConditions": "Termini e condizioni",
    "copyright": "© 2026 Flipping Pal - Tutti i diritti riservati. Di",
    "creatorLabel": "Boophie (Content Creator)"
  }
}
